import React, { useState } from "react";
import { Row, Col, FormGroup } from "reactstrap";
import { useDispatch } from "react-redux";

import { useFormik } from "formik";
import * as Yup from "yup";
import { Loader } from "../Utils/Loader";
import { toast } from "react-toastify";

import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import CommonButton from "../Utils/CommonButton";

import { stockoutCreationSO } from "../../slices/SO/StockoutCreate/thunk";
import { approvedRequestSO } from "../../slices/SO/ApprovedRequestSO/thunk";

function SOStockOutForm({ closeModal, stockOutData, refreshSOList }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      itemName: stockOutData?.itemName || "",
      itemId: stockOutData?.itemId || "",
      sku: stockOutData?.sku || "",
      quantity: Number(stockOutData?.quantity || 0),
      stockOutQty: Number(stockOutData?.stockOutQty ?? 0),
      fromLocation: stockOutData?.fromlocation || "",
    },

    enableReinitialize: true,

    validationSchema: Yup.object({
      stockOutQty: Yup.number()
        .typeError("Stock Out Quantity must be a number")
        .required("Stock Out Quantity is required")
        .min(1, "Minimum 1"),
    }),

    onSubmit: (values) => {
      if (Number(values.stockOutQty) > Number(stockOutData?.stockOutQty)) {
        toast.error(
          "Stock Out Quantity cannot be greater than Approved Quantity",
        );
        return;
      }

      const payload = {
        itemid: values.itemId,
        stockoutquantity: Number(values.stockOutQty),
        transactiontype: "stockout",
        fromlocation: stockOutData.fromlocationId,
      };

      dispatch(
        stockoutCreationSO(stockOutData?.soNumber, payload, setLoading, () => {
          dispatch(
            approvedRequestSO(
              { status: "completed" },
              stockOutData?.soNumber,
              values.itemId,
              setLoading,
              () => {
                refreshSOList?.();
                closeModal();
              },
            ),
          );
        }),
      );
    },
  });

  const { values, errors, touched, handleChange, handleSubmit } = formik;

  return (
    <>
      {loading && <Loader />}
      <form onSubmit={handleSubmit}>
        <Row className="gy-3">
          {/* ITEM NAME */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="Product Name" />
              <InputField value={values.itemName} disabled />
            </FormGroup>
          </Col>

          {/* ITEM ID */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="Product ID" />
              <InputField value={values.itemId} disabled />
            </FormGroup>
          </Col>

          {/* SKU */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="SKU" />
              <InputField value={values.sku} disabled />
            </FormGroup>
          </Col>

          {/* QUANTITY */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="Net Quantity" />
              <InputField value={values.quantity} disabled />
            </FormGroup>
          </Col>

          {/* FROM LOCATION */}
          <Col md={6}>
            <FormGroup>
              <LabelText displayText="From Location" />
              <InputField value={values.fromLocation} disabled />
            </FormGroup>
          </Col>

          {/* STOCK OUT QTY */}
          <Col md={6}>
            <FormGroup>
              <LabelText
                displayText="Stock Out Quantity"
                className={"text-danger"}
                important={"*"}
              />

              <InputField
                name="stockOutQty"
                type="number"
                placeholder="Enter Quantity"
                value={values.stockOutQty}
                handleChange={handleChange}
                invalid={touched.stockOutQty && errors.stockOutQty}
              />
            </FormGroup>
          </Col>

          {/* BUTTONS */}
          <div className="d-flex justify-content-center w-100 gap-2 flex-wrap pe-1 pb-1 mt-4">
            <div className="d-flex gap-2 justify-content-center">
              <CommonButton
                outline={true}
                className={
                  "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                color={"main-color"}
                type={"reset"}
                buttonAction={() => {
                  closeModal();
                }}
                buttonText={"Cancel"}
                icon={
                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              />

              <CommonButton
                color={"main-color"}
                className={
                  "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                icon={
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                type={"submit"}
                buttonText={"Submit"}
                buttonAction={handleSubmit}
                disabled={loading}
              />
            </div>
          </div>
        </Row>
      </form>
    </>
  );
}

export default SOStockOutForm;
